import React, { useEffect, useState } from "react";
import Select from "react-select";
// import TimeKeeper from 'react-timekeeper';

//component
import Modal from "../Modal";

// style
import RightSidebarStyle from "./style";

//img
import Close from "../../Assets/Close.svg";
import TimeIcon from "../../Assets/Themes/Time.svg";

// -- redux
import { connect } from "react-redux";
import {
  GetStates,
  AddZip,
  EditZip,
  DeleteZip,
} from "../../Redux/Actions/ZipAction";
import { Switch, ConfigProvider, TimePicker, Space } from "antd";
import dayjs from "dayjs";

function RightSideBar(props) {
  const [response, setResponse] = useState(false);
  const [ZipCode, setZipCode] = useState("");
  const [ZipError, setZipError] = useState("");
  const [City, setCity] = useState("");
  const [CityError, setCityError] = useState("");
  const [State, setState] = useState("");
  const [StateID, setStateID] = useState("");
  const [ServiceStartTime, setServiceStartTime] = useState("");
  const [ServiceEndTime, setServiceEndTime] = useState("");
  const [OpenModal, setModal] = useState(false);
  const [ShowTimeStartKeeper, setShowTimeStartKeeper] = useState(false);
  const [ShowTimeEndKeeper, setShowTimeEndKeeper] = useState(false);

  useEffect(() => {
    document.getElementById("SidebarForm").scrollTo(0, 0);
    props.item_data && setZipCode(props.item_data.zip_code);
    props.item_data && setCity(props.item_data.city);
    props.item_data && setState(props.item_data.state);
    props.item_data &&
      setServiceStartTime(dayjs(props.item_data.service_start_time, "HH:mm"));
    props.item_data &&
      setServiceEndTime(dayjs(props.item_data.service_end_time, "HH:mm"));
  }, [props]);

  useEffect(() => {
    props.GetStates("");
  }, []);

  useEffect(() => {
    setTimeout(function () {
      setResponse(true);
    }, 1000);
  }, []);

  const colourStyles = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: "#3C3C3C",
      border: state.isFocused ? "1px solid #A0A0A0" : "1px solid #3C3C3C",
      transition: "all 0.25s linear 0s",
      "&:hover": {
        border: "1px solid #A0A0A0",
      },
      padding: "4px 6px",
      boxShadow: state.isFocused ? null : null,
    }),
    singleValue: (baseStyles, state) => ({
      ...baseStyles,
      color: state.isFocused ? "#ffffff" : "#ffffff",
      backgroundColor: "#3C3C3C",
    }),
  };

  const CloseSidebar = (e) => {
    e.preventDefault();
    document.getElementById("SidebarForm").scrollTo(0, 0);
    setZipCode("");
    setCity("");
    setState("");
    setServiceStartTime("");
    setServiceEndTime("");
    setShowTimeStartKeeper(false);
    props.close();
  };
  const handleModal = (e, type) => {
    e.preventDefault();
    if (type === "delete") {
      setModal(type);
    } else {
      if (ZipCode.length < 5) {
        setZipError("Zipcode must have atleast 5 digits");
      } else {
        setModal(type);
      }
    }
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    document.getElementById("SidebarForm").scrollTo(0, 0);
    if (type === "add_yes") {
      const data = {
        zip_code: ZipCode,
        state: State,
        city: City,
        service_start_time: ServiceStartTime,
        service_end_time: ServiceEndTime,
      };
      props.AddZip(data);
    } else if (type === "add_no") {
      setModal(false);
    } else if (type === "update_yes") {
      const data = {
        id: props.item_data.id,
        zip_code: ZipCode,
        state: State,
        city: City,
        service_start_time: ServiceStartTime,
        service_end_time: ServiceEndTime,
      };
      props.EditZip(data);
    } else if (type === "update_no") {
      setModal(false);
    } else if (type === "delete_yes") {
      props.DeleteZip(props.item_data.id);
    } else if (type === "delete_no") {
      setModal(false);
    }
    if (type === "add_yes" || type === "update_yes" || type === "delete_yes") {
      setModal(false);
      setZipCode("");
      setCity("");
      setState("");
      setServiceStartTime("");
      setServiceEndTime("");
      setShowTimeStartKeeper(false);
      setShowTimeEndKeeper(false);
      props.close();
    }
  };

  const selectState = (selected) => {
    setState(selected.label);
    setStateID(selected.value);
  };

  const renderList = () => {
    if (props.states_data && props.states_data.data) {
      return props.states_data.data.map((state) => ({
        label: state.state_name,
        value: state.state_name,
      }));
    }
  };

  const showAMPM = (time) => {
    let AMPM = "";
    let hourStr = "";
    let minStr = "";
    if (time) {
      let hours = parseInt(time.split(":")[0], 10);
      let minutes = parseInt(time.split(":")[1], 10);
      if (hours > 11) {
        if (hours > 12) hours = hours - 12;
        AMPM = "PM";
      } else {
        AMPM = "AM";
        if (hours === 0) hours = 12;
      }
      if (hours < 10) {
        hourStr = "0" + String(hours);
      } else {
        hourStr = String(hours);
      }
      if (minutes < 10) {
        minStr = "0" + String(minutes);
      } else {
        minStr = String(minutes);
      }
      return hourStr + " : " + minStr + " " + AMPM;
    } else {
      return time;
    }
  };

  const handleZipCode = (e) => {
    let expression = /^[0-9]+$/;
    let regex = new RegExp(expression);
    if (e.target.value.length > 0) {
      if (e.target.value.match(regex)) {
        setZipError("");
        setZipCode(e.target.value);
      } else {
        setZipError("Only numbers are allowed");
      }
    } else {
      setZipCode(e.target.value);
    }
  };

  const handleCity = (e) => {
    setZipError("");
    let expression = /^[a-zA-Z ]*$/;
    let regex = new RegExp(expression);
    if (e.target.value.match(regex)) {
      if (e.target.value.length > 50) {
        setCityError("more than 50 characters are not allowed");
      } else {
        setCityError("");
        setCity(e.target.value);
      }
    } else {
      setCityError("Only characters are allowed");
      setTimeout(function () {
        setCityError("");
      }, 3000);
    }
  };

  const onCalendarStartChange = (value) => {
    if (value === null) {
      // clear button selected
      setServiceStartTime(null);
      console.log("Cleared");
      return;
    }
    setServiceStartTime(dayjs(value));
  };

  const onCalendarEndChange = (value) => {
    if (value === null) {
      // clear button selected
      setServiceEndTime(null);
      console.log("Cleared");
      return;
    }
    setServiceEndTime(dayjs(value));
  };

  useEffect(() => {
    props.edit_data &&
      response &&
      props.response({
        type: props.edit_data.status,
        message: props.edit_data.message,
      });
  }, [props.edit_data]);

  useEffect(() => {
    props.delete_data &&
      response &&
      props.response({
        type: props.delete_data.status,
        message: props.delete_data.message,
      });
  }, [props.delete_data]);

  useEffect(() => {
    props.add_data &&
      response &&
      props.response({
        type: props.add_data.status,
        message: props.add_data.message,
      });
  }, [props.add_data]);

  return (
    <>
      {props && props.sidebar && (
        <div onClick={(e) => CloseSidebar(e)} className="dark-overlay" />
      )}
      <div
        className={
          props && props.sidebar
            ? "dark-background right-sidebar-wrap"
            : "dark-background right-sidebar-wrap right-sidebar-wrap-close"
        }
      >
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="text-uppercase text-white">{props.Type} ZIPCODE</h5>
          <img
            onClick={(e) => CloseSidebar(e)}
            src={Close}
            alt="Close"
            className="cursor-pointer"
          />
        </div>
        <form className="sidebar-form-wrap" id="SidebarForm">
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              Zipcode <span className="text-danger">*</span>
            </label>
            <input
              value={ZipCode}
              onChange={(e) => handleZipCode(e)}
              type="text"
              placeholder="Enter Code"
              className="w-100 input-style"
            />
            {ZipError && <p className="text-danger f-12">{ZipError}</p>}
          </div>
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              City <span className="text-danger">*</span>
            </label>
            <input
              value={City}
              onChange={(e) => handleCity(e)}
              type="text"
              placeholder="Enter City"
              className="w-100 input-style"
            />
            {CityError && <p className="text-danger f-12">{CityError}</p>}
          </div>
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              State <span className="text-danger">*</span>
            </label>
            {props.states_data && renderList() && (
              <Select
                value={
                  renderList().filter(function (option) {
                    return option.label === State;
                  }) || ""
                }
                onChange={(selected) => selectState(selected)}
                options={renderList()}
                styles={colourStyles}
                placeholder="Select State"
              />
            )}
          </div>
          <div className="mt-4 Time-wrapper position-relative">
            <label className="text-grey-6 f-16 d-block mb-1">
              Service Start Time <span className="text-danger">*</span>
            </label>
            <ConfigProvider
              theme={{
                components: {
                  DatePicker: {
                    activeBorderColor: "#BDFF00",
                  },
                },
                token: {
                  colorBgContainer: "#646464",
                  colorTextPlaceholder: "#FFFFFF",
                  colorIcon: "#FFFFFF",
                  colorTextLightSolid: "#FFFFFF",
                  colorTextDisabled: "#FFFFFF",
                  colorTextDescription: "#FFFFFF",
                },
              }}
            >
              <Space>
                <TimePicker
                  status={ZipError === true ? "error" : "success"}
                  variant={"Filled"}
                  value={ServiceStartTime}
                  format={"hh:mm A"}
                  use12Hours={true}
                  showNow={false}
                  onClear
                  onCalendarChange={onCalendarStartChange}
                  style={{
                    border: "1px solid #FFFFFF",
                  }}
                />
              </Space>
            </ConfigProvider>
          </div>
          <div className="mt-4 Time-wrapper position-relative">
            <label className="text-grey-6 f-16 d-block mb-1">
              Service End Time <span className="text-danger">*</span>
            </label>
            <ConfigProvider
              theme={{
                components: {
                  DatePicker: {
                    activeBorderColor: "#BDFF00",
                  },
                },
                token: {
                  colorBgContainer: "#646464",
                  colorTextPlaceholder: "#FFFFFF",
                  colorIcon: "#FFFFFF",
                  colorTextLightSolid: "#FFFFFF",
                  colorTextDisabled: "#FFFFFF",
                  colorTextDescription: "#FFFFFF",
                },
              }}
            >
              <Space>
                <TimePicker
                  status={ZipError === true ? "error" : "success"}
                  variant={"Filled"}
                  value={ServiceEndTime}
                  format={"hh:mm A"}
                  use12Hours={true}
                  showNow={false}
                  onClear
                  onCalendarChange={onCalendarEndChange}
                  style={{
                    border: "1px solid #FFFFFF",
                  }}
                />
              </Space>
            </ConfigProvider>
          </div>
          <div className="mt-5 mb-5 text-center">
            {props.Type === "Add" && (
              <button
                onClick={(e) => handleModal(e, "add")}
                className="form-button"
                disabled={
                  !(
                    ZipCode &&
                    City &&
                    State &&
                    ServiceStartTime &&
                    ServiceEndTime
                  )
                }
              >
                Save
              </button>
            )}
            {props.Type === "Edit" && (
              <div className="d-flex align-items-center justify-content-center">
                <button
                  onClick={(e) => handleModal(e, "delete")}
                  className="form-button form-button-ghost f-14 mr-2"
                >
                  Delete
                </button>
                <button
                  disabled={
                    !(
                      ZipCode &&
                      City &&
                      State &&
                      ServiceStartTime &&
                      ServiceEndTime
                    )
                  }
                  onClick={(e) => handleModal(e, "update")}
                  className="form-button ml-2 f-14"
                >
                  Update
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
      {OpenModal && (
        <Modal
          Name="zipcode"
          Type={OpenModal}
          Close={(e, type) => CloseModal(e, type)}
        />
      )}
      <RightSidebarStyle />
    </>
  );
}

const mapStateToProps = ({ ZipReducer }) => {
  const { loading, states_data, delete_data, add_data, edit_data } = ZipReducer;
  return { loading, states_data, delete_data, add_data, edit_data };
};

const mapDispatchToProps = {
  GetStates,
  AddZip,
  EditZip,
  DeleteZip,
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSideBar);
